export const SCENE_OBJECT_TYPES = {
  "sceneChange": "sceneChange",
  "guestSeat": "guestSeat",
  "webLink": "webLink",
  "screenStream": "screenStream",
  "youtube": "youtube",
  "iframeAgent": "iframeAgent",
  "iframeElement": "iframeElement",
  "timerElement": "timerElement",
  "vraiAgent": "vraiAgent",
  "profile": "profile",
  "imageGallery": "imageGallery",
  "embeddedWebpage": "embeddedWebpage",
  "videoGallery": "videoGallery",
  "audioAnalyzer": "audioAnalyzer",
  "chessGame": "chessGame",
  "videoPlayer": "videoPlayer",
  "videoPlayerWebGL": "videoPlayerWebGL",
  "vrMusicObject": "vrMusicObject",
  "vrInvisibleAction": "vrInvisibleAction",
}

export const EDITOR_ACTIONS = {
  "public_space": "public_space",
  "paid_space": "paid_space",
  "welcome_screen": "welcome_screen",
  "hide_from_space_browser": "hide_from_space_browser",
  "disable_guest_restrictions": "disable_guest_restrictions",
  "translated_subtitles_for_seats": "translated_subtitles_for_seats",
  "translated_subtitles_for_tour": "translated_subtitles_for_tour",
  "youtube_element": "youtube_element",
}

export const availableFeatures = {
  content_rights: "content_rights",
  create_premium_space: "create_premium_space",
  create_public_space: "create_public_space",
  generic_1_1_chat: "generic_1_1_chat",
  generic_buddy_list: "generic_buddy_list",
  generic_chess_game: "generic_chess_game",
  generic_invite_jump_to_user: "generic_invite_jump_to_user",
  generic_invite_to_chair: "generic_invite_to_chair",
  generic_lock_room: "generic_lock_room",
  generic_run_1_1_tour: "generic_run_1_1_tour",
  generic_run_private_tour: "generic_run_private_tour",
  generic_run_tours_premium: "generic_run_tours_premium",
  generic_run_tours_public: "generic_run_tours_public",
  generic_screenshare: "generic_screenshare",
  generic_screenshare_in_tour: "generic_screenshare_in_tour",
  generic_take_seat: "generic_take_seat",
  generic_video_calls: "generic_video_calls",
  generic_view_all_interactions: "generic_view_all_interactions",
  services_agency_service_discount: "services_agency_service_discount",
  services_support_tidio_chat: "services_support_tidio_chat",
  translation_show_subtitles: "translation_show_subtitles"
};
